<template>
    <div id="container-stations-carousel">
        <div id="container-button-close-panel">
            <span
                id="btn-close-panel"
                @click="Close_Sidebar()" 
            >
                <b>x</b>
            </span>
        </div>
        <a-collapse 
            class="container-collapse-station"
            default-active-key="1" 
            v-for="(station,index) in infoStation" 
            :key="index"
        >
            <span 
                class="btn-close-station"
                @click="Close_Station(index),Reload()"
            >
                x
            </span>
            <a-collapse-panel 
                :key="index" 
                :header="station[0].name"
            >
                <StationListMenu 
                    :station-inf="station[0]" 
                    :station-chart="dataStation[index]"
                    :indicator-a3="rainfallA3[index]"
                    :indicator-a25="rainfallA25[index]"
                    :index="index" 
                    :key="renderKey"
                />
            </a-collapse-panel>
        </a-collapse>
    </div> 
</template>

<script>
    import StationListMenu from '@/components/StationListMenu/StationListMenu.vue';
    import {mapState, mapActions} from 'vuex';

    export default {

        name: 'StationMenu',

        data(){
            return{
                renderKey: 1
            }
        },

        components: {
            StationListMenu
        },

        computed: {
            ...mapState('station_id',['infoStation','dataStation','showMenu','rainfallA3','rainfallA25'])
        },

        methods: {
            ...mapActions('station_id',['Close_Sidebar','Close_Station']),

            /*
            * Renderizar de manera independiente cada menú de estación
            * para que no se reutilicen las gráficas (no se reutilizan los componentes)
            */

            Reload(){
                this.renderKey ++;
            }
        }
    };
</script>

<style scoped lang="scss">
    #container-stations-carousel {
        background-color: $bg-main-color-transparent;
        border: 2px solid $custom-color-transparent;
        height: 100%;
        overflow-y: scroll;
        padding: 0 1em;
        position: absolute;
        right: 0;
        width: 35em;
        z-index: 1;

        #container-button-close-panel {
            text-align: right;
            margin: .2em 0;

            #btn-close-panel {
                cursor: pointer;
                font-size: 1.5em;
                color:  $dark-color-transparent;
            }

            #btn-close-panel:hover {
                color: $dark-color;
            }
        }

        .container-collapse-station {
            margin-bottom: .5em;

            .btn-close-station {
                cursor: pointer;
                margin-left: 90%;
                margin-top: .5em;
                position: absolute;
                font-weight: bold;
                font-size: 1.2em;
                color: $custom-color-transparent;
                z-index: 2;
            }

            .btn-close-station:hover {
                color: $custom-color;
            }
        }
    }

    /*
    * El -webkit-scrollbar es para cambiar el aspecto del scroll
    * por un scroll redondeado de color negro
    */

    #container-stations-carousel::-webkit-scrollbar {
        -webkit-appearance: none;
    }

    #container-stations-carousel::-webkit-scrollbar:vertical {
        width: .5em;
    }

    #container-stations-carousel::-webkit-scrollbar-button:increment,.container::-webkit-scrollbar-button {
        display: none;
    }

    #container-stations-carousel::-webkit-scrollbar:horizontal {
        height: 10em;
    }

    #container-stations-carousel::-webkit-scrollbar-thumb {
        background-color: $bg-custom-color;
        border-radius: 5em;
        border: 2px solid $custom-color;
    }

    #container-stations-carousel::-webkit-scrollbar-track {
        border-radius: 1em;
    }

    /* ------------------- end scroll ------------------- */

    @media screen and (max-width: 600px), screen and (max-height: 412px) {
        #container-stations-carousel {
            width: 100%;

            .container-collapse-station .btn-close-station {
                margin-left: 85%;
            }
        }
    }

    @media (min-width: 1500px) {
        #container-stations-carousel {
            width: 45em;
            font-weight: 2em;

            .container-collapse-station {
                .btn-close-station {
                    font-size: .9em;
                    margin-top: .3em;
                }
            }
        }

        .ant-collapse {
            font-size: 1.2em;
        }
    }
</style>
